module.exports = class WorkingHoursCtrl
  constructor: ->
    'ngInject'

  submit: ->
    @onSubmit(salon: @salon)
